import {Dialog, DialogBackdrop} from '@headlessui/react'
import {AnimatePresence, motion, MotionConfig} from 'framer-motion'
import {twJoin} from 'tailwind-merge'

import type {SlideoutVariants} from './types'
import type {PropsWithChildren} from 'react'
import type {DialogProps as HUIDialogProps} from '@headlessui/react'

export type SlideoutProps = HUIDialogProps & PropsWithChildren & {
  variant?: SlideoutVariants
}

export const Slideout = ({
  variant = 'content',
  onClose,
  children,
  unmount,
  ...restProps
}: SlideoutProps) => (
  <AnimatePresence>
    {restProps.open && (
      <Dialog
        static
        onClose={onClose}
        {...restProps}
      >
        <MotionConfig transition={{duration: 0.3, mass: 1, stiffness: 180, damping: 30}}>
          <DialogBackdrop
            as={motion.div}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            className={'fixed inset-0 z-50 bg-scrim-primary/25'}
          />
          <div className={'fixed inset-0 z-50 overflow-hidden'}>
            <motion.div
              initial={'hidden'}
              animate={'visible'}
              exit={'hidden'}
              variants={{visible: {x: 0}, hidden: {x: '100%'}}}
              className={twJoin(
                'h-full flex items-center',
                variant === 'content' && 'md:p-spacing-12 justify-end',
                variant === 'crud-cufe' && [
                  'justify-center',
                  'tablet:py-spacing-40',
                  'md:p-spacing-12 md:justify-end',
                  'xl:p-spacing-0 xl:justify-center',
                ],
              )}
            >
              {children}
            </motion.div>
          </div>
        </MotionConfig>
      </Dialog>
    )}
  </AnimatePresence>
)
